import { AlignSelfType } from 'common/types/styleTypes'
import React from 'react'
import { Alignment } from '.'
import { AlignType as AlignmentValueType } from './types'

const alignTypeToAlignmentValue = (
  align: AlignSelfType | undefined,
): AlignmentValueType => {
  switch (align) {
    case 'flex-start':
      return 'left'
    case 'center':
      return 'center'
    case 'flex-end':
      return 'right'
    default:
      return 'left'
  }
}

const alignmentValueToAlignType = (
  align: AlignmentValueType,
): AlignSelfType => {
  switch (align) {
    case 'left':
      return 'flex-start'
    case 'center':
      return 'center'
    case 'right':
      return 'flex-end'
    default:
      return 'flex-start'
  }
}

export interface FlexAlignmentProps {
  className?: string
  value?: AlignSelfType
  update: (align: AlignSelfType) => void
}

export const FlexAlignment = ({
  className,
  value,
  update,
}: FlexAlignmentProps) => {
  const onChange = (align: AlignmentValueType) => {
    const alignType = alignmentValueToAlignType(align)
    update(alignType)
  }

  return (
    <Alignment
      value={alignTypeToAlignmentValue(value)}
      update={onChange}
      hideJustifyOption
      className={className}
    />
  )
}
